import styled from "styled-components";

export const FileUploadBoxFromJsonContainer = styled("div").withConfig({
   shouldForwardProp: p => !["isLastElement"].includes(p)
})<{ isLastElement?: boolean }>`
   width: 100%;
   margin-top: 32px;
`;
